import state from "./state";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
export const CompanyStoreV2 = {
  state,
  mutations,
  getters,
  actions,
  namespaced: true,
};
